import TYPE from '../storeType'
const state={
  izOutCamera:sessionStorage.getItem('izOutCamera'),
  schoolId:''
  // schoolId:sessionStorage.getItem('schoolId'),


};
const action={
  [TYPE.izOutCamera]({commit, state},msg){
    commit([TYPE.izOutCamera],msg)
  },
  [TYPE.getSchoolId]({commit, state},msg){
    commit([TYPE.getSchoolId],msg)
  }
};

const mutations={
  [TYPE.izOutCamera](state,msg){
    state.izOutCamera=msg;
  },
  [TYPE.getSchoolId](state,msg){
      state.schoolId=msg;
  }
};

export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js